import React, { useContext, useState, useEffect } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppContext } from './context/AppContext';
import { Role } from './types';

import Sidebar from './components/layout/Sidebar';
import Header from './components/layout/Header';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import History from './pages/History';
import AdminMeters from './pages/AdminMeters';
import AdminUsers from './pages/AdminUsers';
import AdminAreas from './pages/AdminAreas';
import { ProductionCalendar } from './pages/ProductionCalendar';

const App: React.FC = () => {
  const { currentUser, loading } = useContext(AppContext);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isDesktopCollapsed, setIsDesktopCollapsed] = useState(false);

  // Limpiar localStorage heredado que satura la memoria (Fix para el Quota Exceeded Error)
  useEffect(() => {
    try {
      ['users', 'areas', 'meters', 'stopRecords', 'currentUser'].forEach(key => localStorage.removeItem(key));
    } catch (e) {
      console.warn('Error limpiando LocalStorage heredado', e);
    }
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center">
        <div className="h-12 w-12 border-4 border-brand-primary/20 border-t-brand-primary rounded-full animate-spin"></div>
        <p className="mt-4 text-gray-500 font-medium">Validando sesión...</p>
      </div>
    );
  }

  return (
    <HashRouter>
      {!currentUser ? (
        <Routes>
          {/* Si no hay sesión, cualquier URL te arroja al login y limpia el link en el navegador */}
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      ) : (
        <div className="fixed inset-0 flex bg-background-light overflow-hidden">
          <Sidebar
            isOpen={isSidebarOpen}
            onClose={() => setIsSidebarOpen(false)}
            isDesktopCollapsed={isDesktopCollapsed}
            onDesktopToggle={() => setIsDesktopCollapsed(!isDesktopCollapsed)}
          />

          {/* Contenedor Principal Ajustado con Flexbox Seguro */}
          <div className="flex-1 flex flex-col h-full overflow-hidden">
            <Header
              onMenuClick={() => setIsSidebarOpen(true)}
              isDesktopCollapsed={isDesktopCollapsed}
              onDesktopToggle={() => setIsDesktopCollapsed(!isDesktopCollapsed)}
            />

            <main className="flex-1 w-full overflow-y-auto py-4 px-4 md:px-6">
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/history" element={<History />} />
                <Route path="/calendar" element={<ProductionCalendar />} />
                {currentUser.role === Role.ADMIN && (
                  <>
                    <Route path="/admin/areas" element={<AdminAreas />} />
                    <Route path="/admin/meters" element={<AdminMeters />} />
                    <Route path="/admin/users" element={<AdminUsers />} />
                  </>
                )}
                <Route path="/login" element={<Navigate to="/dashboard" replace />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </main>
          </div>
        </div>
      )}
    </HashRouter>
  );
};

export default App;
